import React from "react";

export const Services = (props) => {
  if (!props.data) return "loading";

  const firstRow = props.data.slice(0, 3);
  const secondRow = props.data.slice(3);

  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
        </div>
        <div className="row">
          {firstRow.map((d, i) => (
            <div key={`${d.name}-${i}`} className="col-md-4">
              <i className={d.icon}></i>
              <div className="service-desc">
                <h3>{d.name}</h3>
                <p>{d.text}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="row second-row">
          {secondRow.map((d, i) => (
            <div key={`${d.name}-${i}`} className="col-md-4">
              <i className={d.icon}></i>
              <div className="service-desc">
                <h3>{d.name}</h3>
                <p>{d.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
